const RatingProps = {
	0: { name: 'Unrated', color: '', bg: '', hover: '' },
	1: { name: 'Critical', color: 'text-danger', bg: '#ff1d62', hover: '#A70100' },
	2: { name: 'High', color: 'text-warning', bg: '#FF6300', hover: '#BB4900' },
	3: { name: 'Medium', color: 'text-caution', bg: '#FFC303', hover: '#CC9C00' },
	4: { name: 'Low', color: 'text-success', bg: '#0DA109', hover: '#065A04' },
	5: { name: 'Info', color: 'text-gray', bg: '#A4ACB8', hover: '#667286' },
};

export default RatingProps;